export default __webpack_public_path__ + "static/media/Shop Local Mockup Contest Notification.82e9cec5.svg";